import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetSessionNotes = (studentId, enabled) => {
    const {
        isFetching: isLoading, data: sessionNotes, error,
    } = useQuery({
        queryKey: ["SessionNotes", studentId],
        queryFn: () => axiosManager.get$(`parent/api/students/${studentId}/mentorpathway/sessionnotes`).then((response) => response?.data),
        initialData: [],
        retry: 0,
        enabled,
    });

    return {
        isLoading, sessionNotes, error,
    };
};